/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MemberGradeOption } from './MemberGradeOption';
import {
    MemberGradeOptionFromJSON,
    MemberGradeOptionFromJSONTyped,
    MemberGradeOptionToJSON,
    MemberGradeOptionToJSONTyped,
} from './MemberGradeOption';
import type { WarehouseTransportMethodsDto } from './WarehouseTransportMethodsDto';
import {
    WarehouseTransportMethodsDtoFromJSON,
    WarehouseTransportMethodsDtoFromJSONTyped,
    WarehouseTransportMethodsDtoToJSON,
    WarehouseTransportMethodsDtoToJSONTyped,
} from './WarehouseTransportMethodsDto';
import type { OrderTypeGroupOption } from './OrderTypeGroupOption';
import {
    OrderTypeGroupOptionFromJSON,
    OrderTypeGroupOptionFromJSONTyped,
    OrderTypeGroupOptionToJSON,
    OrderTypeGroupOptionToJSONTyped,
} from './OrderTypeGroupOption';

/**
 * 
 * @export
 * @interface DeliverFeeConfigInitRespVo
 */
export interface DeliverFeeConfigInitRespVo {
    /**
     * 启用仓库及各仓库配置的运输方式
     * @type {Array<WarehouseTransportMethodsDto>}
     * @memberof DeliverFeeConfigInitRespVo
     */
    warehouses?: Array<WarehouseTransportMethodsDto>;
    /**
     * 启用的会员等级
     * @type {Array<MemberGradeOption>}
     * @memberof DeliverFeeConfigInitRespVo
     */
    userGrades?: Array<MemberGradeOption>;
    /**
     * 国际运费订单分组
     * @type {Array<OrderTypeGroupOption>}
     * @memberof DeliverFeeConfigInitRespVo
     */
    internationalOrderTypeGroups?: Array<OrderTypeGroupOption>;
    /**
     * 韩国国内运费订单分组
     * @type {Array<OrderTypeGroupOption>}
     * @memberof DeliverFeeConfigInitRespVo
     */
    krOrderTypeGroups?: Array<OrderTypeGroupOption>;
}

/**
 * Check if a given object implements the DeliverFeeConfigInitRespVo interface.
 */
export function instanceOfDeliverFeeConfigInitRespVo(value: object): value is DeliverFeeConfigInitRespVo {
    return true;
}

export function DeliverFeeConfigInitRespVoFromJSON(json: any): DeliverFeeConfigInitRespVo {
    return DeliverFeeConfigInitRespVoFromJSONTyped(json, false);
}

export function DeliverFeeConfigInitRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliverFeeConfigInitRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'warehouses': json['warehouses'] == null ? undefined : ((json['warehouses'] as Array<any>).map(WarehouseTransportMethodsDtoFromJSON)),
        'userGrades': json['userGrades'] == null ? undefined : ((json['userGrades'] as Array<any>).map(MemberGradeOptionFromJSON)),
        'internationalOrderTypeGroups': json['internationalOrderTypeGroups'] == null ? undefined : ((json['internationalOrderTypeGroups'] as Array<any>).map(OrderTypeGroupOptionFromJSON)),
        'krOrderTypeGroups': json['krOrderTypeGroups'] == null ? undefined : ((json['krOrderTypeGroups'] as Array<any>).map(OrderTypeGroupOptionFromJSON)),
    };
}

export function DeliverFeeConfigInitRespVoToJSON(json: any): DeliverFeeConfigInitRespVo {
    return DeliverFeeConfigInitRespVoToJSONTyped(json, false);
}

export function DeliverFeeConfigInitRespVoToJSONTyped(value?: DeliverFeeConfigInitRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warehouses': value['warehouses'] == null ? undefined : ((value['warehouses'] as Array<any>).map(WarehouseTransportMethodsDtoToJSON)),
        'userGrades': value['userGrades'] == null ? undefined : ((value['userGrades'] as Array<any>).map(MemberGradeOptionToJSON)),
        'internationalOrderTypeGroups': value['internationalOrderTypeGroups'] == null ? undefined : ((value['internationalOrderTypeGroups'] as Array<any>).map(OrderTypeGroupOptionToJSON)),
        'krOrderTypeGroups': value['krOrderTypeGroups'] == null ? undefined : ((value['krOrderTypeGroups'] as Array<any>).map(OrderTypeGroupOptionToJSON)),
    };
}

